module.exports = __webpack_public_path__ + "static/media/Extreme-Elements_RGB.550b42e9.svg";